import {
  faCaretRight,
  faCaretDown,
  faCheck,
  faXmark,
  faTrash,
  faPenToSquare,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { faFile, faFolder } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Box,
  TextField,
  Typography,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./styles.css";
import { ThemeProvider, createTheme } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import NestedThreeDotMenu from "../NestedThreeDotMenu";
import { isAdmin } from "../../tempGlobal";
import FolderStructureSkeleton from "../FolderStructureSkeleton";
import { useTranslation } from "react-i18next";
import InformationPopup from "../InformationPopup";
import { setIsSelectedReport, setReportFoldersList, setSelectedReportEntity, setStructuredReportFoldersList } from "../../redux/reducers/evaluation";
import { getEvaluationReportFolders, getEvaluationReportList } from "../../api/reports";
import { ReportStatus, reportStatusName, ReportType, reportTypeName } from "../../api/types";

const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          padding: "0px",
        },
      },
    },
  },
});

const Directory = (props: any) => {
  const { data, isRootFolder, isOpen, manageIsOpen } = props;
  const [renameLabel, setRenameLabel] = useState("");

  const [isRename, setIsRename] = useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const folderList = useSelector(
    (state: any) => state.evaluation.reportFolders
  );
  const [isProcessing, setIsProcessing] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [renameWarning, setRenameWarning] = useState(false);
  const [retainFiles, setRetainFiles] = useState([]);
  const [filesToDelete, setFilesToDelete] = useState([]);
  const [retainFilesIds, setRetainFilesIds] = useState([]);
  const [deleteFilesIds, setFilesToDeleteIds] = useState([]);
  const [foldersToDelete, setFoldersToDelete] = useState([]);
  const clubDetails = useSelector((state: any) => state.clubDetails);
  const selected = useSelector(
    (state: any) => state.evaluation.selectedReportEntity
  );

  const manageOnDrop = (event: React.DragEvent<HTMLDivElement>) => {
    let draggedData = event.dataTransfer.getData("text/plain");
  };

  useEffect(() => {
    // if(!open && selected == data.pathId && !isRootFolder) {
    //     setOpen(true);
    // }
  }, [data]);

  function getChildIds(parentId: any) {
    const childIds: any = [];

    function findChildren(id: any) {
      const children = folderList.filter(
        (obj: any) => obj.parentFolderId === id
      );
      children.forEach((child: any) => {
        childIds.push(child.id);
        findChildren(child.id);
      });
    }

    findChildren(parentId);
    return [parentId, ...childIds];
  }

  const fetchIcon = (type: any) => {
    switch (type) {
      case "folder":
        return faFolder;
      case "file":
        return faFile;
      case "fileHeadings":
        return faArrowRight;
      default:
        return faFile;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <InformationPopup
        isOpen={
          (openDeletePopup &&
            (foldersToDelete.length > 1 ||
              deleteFilesIds.length > 0 ||
              retainFilesIds.length > 0)) ||
          renameWarning
        }
        closeModal={() => {
          if (openDeletePopup) {
            setOpenDeletePopup(false);
          } else {
            setRenameWarning(false);
          }
        }}
        message={
          openDeletePopup
            ? "EVIDENCE_FOLDER_DELETE_WARNING_MESSAGE"
            : "FOLDER_NAME_ALREADY_EXIST_MESSAGE"
        }
        retainedList={retainFiles}
        actionList={filesToDelete}
        singleButtonLabel={"OK"}
        retainMessage={
          openDeletePopup && "EVIDENCES_TO_BE_MOVED_TO_ROOTFOLDERS"
        }
        listMessage={openDeletePopup && "EVIDENCES_TO_BE_DELETED"}
      />
      <Box
        className={`directoryWrapper ${data.pathId == selected && "currentFolder"}`}
      >
        <Box
          className={`directoryContainer`}
          onClick={() => {
            if (data.pathId != selected) {
              dispatch(setSelectedReportEntity(data?.pathId));
            }
            const boolR:any = data?.type === 'file';
            dispatch(setIsSelectedReport(boolR));
          }}
          onDrop={(e: any) => manageOnDrop(e)}
          draggable
        >
          <Box
            className={"carrotIconsContainer"}
            onClick={(e: any) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {!isRootFolder && data?.children?.length && open && (
              <FontAwesomeIcon className="directoryIcons" icon={faCaretDown} />
            )}
            {!isRootFolder && data?.children?.length && !open && (
              <FontAwesomeIcon className="directoryIcons" icon={faCaretRight} />
            )}
          </Box>
          <FontAwesomeIcon
            className="directoryIcons"
            icon={fetchIcon(data?.type)}
          />
          <Typography>{data.name.replace(/^\S+\s/, '')}</Typography>
        </Box>
        <Box>
          {!isRootFolder && (
            <Box>
              {isRename ? (
                <>
                  {!isProcessing ? (
                    <Box className={"renameOptionsWrapper"}>
                      <Tooltip title="Cancel" arrow placement="top">
                        <span onClick={() => setIsRename(false)}>
                          <FontAwesomeIcon
                            className={"iconStyles"}
                            icon={faXmark}
                          />
                        </span>
                      </Tooltip>
                      <Tooltip title="Rename" arrow placement="top">
                        <span
                          onClick={(e: any) => {
                            e.stopPropagation();
                          }}
                        >
                          <FontAwesomeIcon
                            className={"iconStyles"}
                            icon={faCheck}
                          />
                        </span>
                      </Tooltip>
                    </Box>
                  ) : (
                    <CircularProgress
                      sx={{
                        width: "20px !important",
                        height: "20px !important",
                        mr: "10px",
                      }}
                    />
                  )}
                </>
              ) : (
                <>
                  {isProcessing && (
                    <CircularProgress
                      sx={{
                        width: "20px !important",
                        height: "20px !important",
                        mr: "10px",
                      }}
                    />
                  )}
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ ml: 3 }}>
        {((open && data?.children?.length) || isRootFolder) &&
          data?.children?.map((d: any) => (
            <Directory
              data={d}
              isRootFolder={false}
              isOpen={isOpen}
              manageIsOpen={() => {
                setOpen(isOpen);
              }}
            />
          ))}
      </Box>
    </ThemeProvider>
  );
};

const ReportsFolderStructure = (props: any) => {
  // const { } = props;
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const folderList: any = useSelector(
    (state: any) => state.evaluation.reportFolders
  );
  const dataFolders = useSelector(
    (state: any) => state.evaluation.structuredReportFolders
  ) || folderList;
  const currentClub = useSelector((state:any) => state.clubDetails);
  const [t] = useTranslation();
  const [isFetchingFolders, setIsFetchingFolders] = useState(false);

  function buildFolderStructure(folders: any, parentId: number | null) {
    const result: any = [];

    folders?.forEach((folder: any) => {
      if (folder?.parentFolderId === parentId) {
        const children = buildFolderStructure(folders, folder?.id);
        if (children.length) {
          result.push({
            ...folder,
            pathId: folder?.id,
            children: children,
          });
        } else {
          result.push({ ...folder, pathId: folder?.id });
        }
      }
    });

    return result;
  }

  const fetchReportFolderData = async () => {
    setIsFetchingFolders(true);
    const foldersResponse = await getEvaluationReportFolders({
      clubId: currentClub?.id,
    });
    const reportListResponse = await getEvaluationReportList({
      clubId: currentClub?.id,
    });
    const sortedFolders:any = foldersResponse.map((d:any) => {return {...d, type: 'folder'}});
    const evalReports:any = reportListResponse?.evaluationReports.map((d:any) => 
        {
            const parentFolder = foldersResponse.find((fr:any) => fr.name == d.year);
            const typeIndex: ReportType = d.type;
            const statusIndex: ReportStatus = d.status;
            if (parentFolder != null) {
                if (d?.id == null) {
                    return {
                        ...d,
                        id: 'draft',
                        name: t(reportTypeName[typeIndex]) + ' '  + d.year + ' (' + t(reportStatusName[statusIndex]) + ')', 
                        type: 'file',
                        parentFolderId: parentFolder?.id,
                    }
                }
                return {
                    ...d,
                    name: t(reportTypeName[typeIndex]) + ' '  + d.year + ' (' + t(reportStatusName[statusIndex]) + ')', 
                    type: 'file',
                    parentFolderId: parentFolder?.id,
                }
            }
        });
    const finalFolders:any = [...sortedFolders, ...evalReports];
    dispatch(setReportFoldersList(finalFolders));
    if (finalFolders?.length > 0) {
      const folderStruct: any = buildFolderStructure(finalFolders, null);
      dispatch(setStructuredReportFoldersList(folderStruct));
    }
    setIsFetchingFolders(false);
  };

  useEffect(() => {
    !isFetchingFolders && !folderList && fetchReportFolderData();
  }, [currentClub]);

  return (
    <>
      {
        isFetchingFolders ? (
          <FolderStructureSkeleton childFolders={10} />
        ) : (
          <Box>
            {!isFetchingFolders && dataFolders?.length &&
              dataFolders.map((d: any) => {
                return (
                  <Directory
                    data={d}
                    isRootFolder={d?.parentFolderId == null}
                    isOpen={isOpen}
                    manageIsOpen={() => {
                      setIsOpen(!isOpen);
                    }}
                  />
                );
              })}
          </Box>
        )
      }
    </>
  );
};

export default ReportsFolderStructure;
